import { deletedFilters } from "helpers/redux";
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/trailers";
import List from "./list";
import Show from "./show";

export default class Trailers extends Component {
    componentWillUnmount() {
        this.props.clearParams("trailers", deletedFilters());
    }

    render() {
        const { match, location, history } = this.props;
        const rootUrl = `${match.path}/list`;
        const back = () => history.push(rootUrl);
        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                    <Route
                        exact
                        path={rootUrl}
                        render={() => (
                            <List
                                {...this.props}
                                isTable
                                transition="full"
                                title="Список прицепов"
                                nofilter
                                source={source}
                            />
                        )}
                    />
                    <Route
                        path={`${rootUrl}/:id`}
                        render={(rest) => (
                            <Show {...rest} transition="full" title="Прицеп" back={back} source={source} />
                        )}
                    />
                </Switch>
            </div>
        );
    }
}
